// Mock data for TrainerList platform

export const sportCategories = [
  { id: 1, name: 'Chess', icon: '♟️' },
  { id: 2, name: 'Climbing', icon: '🧗' },
  { id: 3, name: 'Cricket', icon: '🏏' },
  { id: 4, name: 'CrossFit', icon: '🏋️' },
  { id: 5, name: 'Curling', icon: '🥌' },
  { id: 6, name: 'Cycling', icon: '🚴' },
  { id: 7, name: 'Dance', icon: '💃' },
  { id: 8, name: 'Diving', icon: '🤿' },
  { id: 9, name: 'Equestrian', icon: '🏇' },
  { id: 10, name: 'Esports Gaming', icon: '🎮' },
  { id: 11, name: 'Fishing', icon: '🎣' },
  { id: 12, name: 'Fitness', icon: '💪' },
  { id: 13, name: 'Golf', icon: '⛳' },
  { id: 14, name: 'Gymnastics', icon: '🤸' },
  { id: 15, name: 'Handball', icon: '🤾' },
  { id: 16, name: 'Ice Hockey', icon: '🏒' },
  { id: 17, name: 'Ice Skating', icon: '⛸️' },
  { id: 18, name: 'Jiu Jitsu', icon: '🥋' },
  { id: 19, name: 'Judo', icon: '🥋' },
  { id: 20, name: 'Karate', icon: '🥋' },
  { id: 21, name: 'Kayak', icon: '🛶' },
  { id: 22, name: 'Kick Box', icon: '🥊' },
  { id: 23, name: 'Martial Arts', icon: '🥋' },
  { id: 24, name: 'Bodybuilding', icon: '💪' },
  { id: 25, name: 'Athletics', icon: '🏃' },
  { id: 26, name: 'Swimming', icon: '🏊' },
  { id: 27, name: 'Yoga', icon: '🧘' },
  { id: 28, name: 'Boxing', icon: '🥊' },
];

export const mockTrainers = [
  {
    id: '690681619f425cd502e1bb44',
    name: 'Troy Tyrell',
    email: 'troy@example.com',
    specializations: ['CrossFit', 'Fitness'],
    location: { province: 'British Columbia', city: 'Vancouver' },
    pricing: '***',
    pricePerHour: 75,
    rating: 4.8,
    reviewCount: 24,
    isSponsored: true,
    status: 'active',
    bio: 'Certified CrossFit trainer with 8+ years of experience helping clients achieve their fitness goals.',
    photos: [
      'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600',
      'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600',
      'https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=600',
    ],
  },
  {
    id: '690681619f425cd502e1bb46',
    name: 'Joss Monette',
    email: 'joss@example.com',
    specializations: ['Bodybuilding', 'Acrobatics'],
    location: { province: 'Ontario', city: 'Ottawa' },
    pricing: '***',
    pricePerHour: 80,
    rating: 4.9,
    reviewCount: 31,
    isSponsored: true,
    status: 'active',
    bio: 'Professional bodybuilder and acrobatics coach. Specialized in competition prep and strength training.',
    photos: [
      'https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=600',
      'https://images.unsplash.com/photo-1574680088814-a440e3dd5f87?w=600',
    ],
  },
  {
    id: '690681619f425cd502e1bb48',
    name: 'Caine Jaglall',
    email: 'caine@example.com',
    specializations: ['Martial Arts', 'Athletics'],
    location: { province: 'Ontario', city: 'Mississauga' },
    pricing: '***',
    pricePerHour: 70,
    rating: 4.7,
    reviewCount: 18,
    isSponsored: true,
    status: 'active',
    bio: 'Martial arts expert with background in multiple disciplines. Focus on technique and mental discipline.',
    photos: [
      'https://images.unsplash.com/photo-1555597673-b21d5c935865?w=600',
      'https://images.unsplash.com/photo-1549719386-74dfcbf7dbed?w=600',
    ],
  },
  {
    id: '690681619f425cd502e1bb4a',
    name: 'Sarah Mitchell',
    email: 'sarah@example.com',
    specializations: ['Yoga', 'Fitness'],
    location: { province: 'Ontario', city: 'Toronto' },
    pricing: '**',
    pricePerHour: 60,
    rating: 4.9,
    reviewCount: 42,
    isSponsored: false,
    status: 'active',
    bio: 'Certified yoga instructor specializing in Vinyasa and Hatha yoga. Helping clients find balance and flexibility.',
    photos: [
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600',
    ],
  },
  {
    id: '690681629f425cd502e1bb4c',
    name: 'Mike Anderson',
    email: 'mike@example.com',
    specializations: ['Boxing', 'Kick Box'],
    location: { province: 'Alberta', city: 'Calgary' },
    pricing: '***',
    pricePerHour: 85,
    rating: 4.8,
    reviewCount: 27,
    isSponsored: false,
    status: 'active',
    bio: 'Former professional boxer with 12 years of competitive experience. Specializing in technique and conditioning.',
    photos: [
      'https://images.unsplash.com/photo-1549719386-74dfcbf7dbed?w=600',
    ],
  },
  {
    id: '690681629f425cd502e1bb4e',
    name: 'Emma Chen',
    email: 'emma@example.com',
    specializations: ['Swimming', 'Athletics'],
    location: { province: 'British Columbia', city: 'Victoria' },
    pricing: '**',
    pricePerHour: 65,
    rating: 4.6,
    reviewCount: 15,
    isSponsored: false,
    status: 'active',
    bio: 'Competitive swimmer and triathlete. Coaching all levels from beginners to competitive athletes.',
    photos: [
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=600',
    ],
  },
];

export const mockUsers = [
  {
    id: 101,
    name: 'John Doe',
    email: 'john@example.com',
    role: 'user',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150',
  },
  {
    id: 102,
    name: 'Jane Smith',
    email: 'jane@example.com',
    role: 'user',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150',
  },
];

export const mockBookings = [
  {
    id: 1,
    userId: 101,
    trainerId: 1,
    trainerName: 'Troy Tyrell',
    date: '2025-02-05',
    time: '10:00',
    duration: 60,
    price: 75,
    status: 'confirmed',
    specialization: 'CrossFit',
  },
  {
    id: 2,
    userId: 101,
    trainerId: 4,
    trainerName: 'Sarah Mitchell',
    date: '2025-02-08',
    time: '14:00',
    duration: 60,
    price: 60,
    status: 'pending',
    specialization: 'Yoga',
  },
];

export const mockMessages = [
  {
    id: 1,
    senderId: 101,
    receiverId: 1,
    senderName: 'John Doe',
    message: 'Hi! I would like to book a session with you for next week.',
    timestamp: '2025-01-28T10:30:00',
    read: true,
  },
  {
    id: 2,
    senderId: 1,
    receiverId: 101,
    senderName: 'Troy Tyrell',
    message: 'Hello! Sure, I have availability on Tuesday and Thursday. What time works for you?',
    timestamp: '2025-01-28T11:15:00',
    read: true,
  },
  {
    id: 3,
    senderId: 101,
    receiverId: 1,
    senderName: 'John Doe',
    message: 'Tuesday at 10 AM would be perfect!',
    timestamp: '2025-01-28T11:20:00',
    read: false,
  },
];

export const mockReviews = [
  {
    id: 1,
    trainerId: '690681619f425cd502e1bb44',
    userId: 101,
    userName: 'John Doe',
    rating: 5,
    comment: 'Excellent trainer! Very knowledgeable and motivating. Highly recommend!',
    date: '2025-01-15',
  },
  {
    id: 2,
    trainerId: '690681619f425cd502e1bb44',
    userId: 102,
    userName: 'Jane Smith',
    rating: 5,
    comment: 'Troy helped me achieve my CrossFit goals. Great technique coaching!',
    date: '2025-01-10',
  },
  {
    id: 3,
    trainerId: '690681619f425cd502e1bb4a',
    userId: 101,
    userName: 'John Doe',
    rating: 5,
    comment: 'Sarah is an amazing yoga instructor. Very patient and knowledgeable.',
    date: '2025-01-20',
  },
];

export const mockPendingTrainers = [
  {
    id: 7,
    name: 'Alex Johnson',
    email: 'alex@example.com',
    specializations: ['Cycling', 'Fitness'],
    location: { province: 'Quebec', city: 'Montreal' },
    pricing: '**',
    pricePerHour: 55,
    status: 'pending',
    registeredDate: '2025-01-25',
    bio: 'Passionate cycling coach with 5 years experience in road and mountain biking.',
    photos: [
      'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?w=600',
    ],
  },
];